
/**
 * Mock function to simulate API calls with a delay
 * @param delay Time in milliseconds to delay the response
 * @param shouldFail Whether the call should fail (for testing error handling)
 * @param response Optional mock response data
 * @returns Promise that resolves to the response or rejects with an error
 */
export const mockApiCall = <T>(
  delay: number = 500,
  shouldFail: boolean = false,
  response?: T
): Promise<T> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (shouldFail) {
        reject(new Error('Mock API call failed'));
      } else {
        resolve(response as T);
      }
    }, delay);
  });
};
